import { FunctionComponent } from 'react';

// Libs
import classnames from 'classnames';
import { PageView } from '@Components/Utils/Lazy/Script';

// Types
import { NextSeoProps } from 'next-seo';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// components'
import Page from '@Components/Utils/Page';
import ComponentLazy from '@Components/Utils/Lazy/Component';
import PlaceholderView from '@Components/UI/PlaceholderView';
import HeadContent from '@Pages/cong-tac-vien/Components/HeadContent';
import LayoutContainer from '@Components/Layout/Components/Container';
import Registration from '@Pages/cong-tac-vien/Components/Registration';

// Styles
import styles from './Collaborators.module.scss';

interface CollaboratorsProps {}

const Collaborators: FunctionComponent<InferGetServerSidePropsType<typeof getServerSideProps> & CollaboratorsProps> =
    () => {
        const { deviceType } = useViewDetected();

        const isMobile = deviceType !== 'desktop';

        const wrapperClassName = classnames([
            styles.page_wrapper,
            {
                [styles.mobile]: isMobile,
            },
        ]);

        return (
            <Page className={wrapperClassName}>
                <div className={styles.wrapper}>
                    <LayoutContainer className={styles.layout_container}>
                        <HeadContent className={styles.head} />

                        <ComponentLazy
                            className={styles.income}
                            placeholder={() => (
                                <PlaceholderView mobileHeight={710} tabletHeight={898} desktopHeight={600} />
                            )}
                            dynamic={() => import('@Pages/cong-tac-vien/Components/Income')}
                        />

                        <ComponentLazy
                            className={styles.need_you}
                            placeholder={() => (
                                <PlaceholderView mobileHeight={661} tabletHeight={591} desktopHeight={560} />
                            )}
                            dynamic={() => import('@Pages/cong-tac-vien/Components/WeNeedYou')}
                        />

                        <ComponentLazy
                            className={styles.question}
                            placeholder={() => (
                                <PlaceholderView mobileHeight={1487} tabletHeight={1359} desktopHeight={1280} />
                            )}
                            dynamic={() => import('@Pages/cong-tac-vien/Components/Question')}
                        />
                    </LayoutContainer>

                    <ComponentLazy
                        className={styles.feedback}
                        placeholder={() => (
                            <PlaceholderView mobileHeight={488} tabletHeight={460} desktopHeight={500} />
                        )}
                        dynamic={() => import('@Pages/cong-tac-vien/Components/Feedback')}
                    />

                    <LayoutContainer className={styles.layout_container}>
                        <Registration className={styles.form} />
                    </LayoutContainer>
                </div>

                <PageView />
            </Page>
        );
    };

export default Collaborators;

export const getServerSideProps: GetServerSideProps = async () => {
    const title = 'eDoctor: Cộng tác viên';
    const seo: NextSeoProps = {
        title,
        openGraph: {
            title,
            type: 'website',
        },
    };

    return {
        props: {
            seo,
        },
    };
};
